import { render, staticRenderFns } from "./infoRestaurants.vue?vue&type=template&id=286ff75a&scoped=true&"
import script from "./infoRestaurants.vue?vue&type=script&lang=js&"
export * from "./infoRestaurants.vue?vue&type=script&lang=js&"
import style0 from "./infoRestaurants.vue?vue&type=style&index=0&id=286ff75a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ff75a",
  null
  
)

export default component.exports